import React, {Fragment} from "react";
import {connect} from "react-redux";
import {ApplicationState, ConnectedReduxProps} from "@reducers/index";
import {Widget} from "@models/widget";
import {deleteRequest, fetchRequest} from "@actions/widget";
import WidgetForm from "@components/widgets/Form";
import {createRequest, updateRequest} from "@actions/widget";
import widgetApi from "@api/widget";
import {injectIntl} from "react-intl";
import {snakeToCamel} from "@utils";

interface PropsFromState {
  loading: boolean;
  data: Widget[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class WidgetFormPage extends React.Component<AllProps> {
  state = {
    widget: null,
    widget_id: this.props.match.params.id,
    type: this.props.match.params.type,
    is_fetched: false
  };
  
  componentDidMount() {
    if (this.state.widget_id) {
      this.fetchItem();
    }
  }
  
  fetchItem = () => {
    widgetApi.getItem({
        params: {
          id: this.state.widget_id,
        },
      }, snakeToCamel(this.state.type))
      .then(({data}) => {
        this.setState({
          widget: data
        });
      })
      .catch(error => console.log(error));
  };
  
  getContent = () => {
    if (this.state.widget_id && !this.state.widget) {
      return null;
    }
    
    return (
      <WidgetForm
        widget={this.state.widget}
        intl={this.props.intl}
        listUrl={"/widgets"}
        editPageUrl={`/widgets/${this.state.type}`}
        type={this.state.type}
        history={this.props.history}
        updateRequest={this.props.updateRequest}
        createRequest={this.props.createRequest}
      />
    );
  };
  
  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}

const mapStateToProps = ({widgets}: ApplicationState) => ({
  loading: widgets.loading,
  errors: widgets.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(WidgetFormPage));
